import React from 'react'
import { FormikProps, getIn } from 'formik'
import { ToggleInput } from '../Input/ToggleInput'
import { Label } from '../Label/Label'
import { ErrorLabel } from '..'
import { FontSize } from '../../../_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'

interface FormToggleProps {
  formik: FormikProps<any>
  name: string
  label?: string
  className?: string
  isDisabled?: boolean
  isRequired?: boolean
  labelSize?: FontSize
  infoText?: string
  highlight?: boolean
  entity?: string
  /** Lado do rótulo + chave na linha. `start` para formulários onde os demais campos alinham à esquerda. */
  align?: 'start' | 'end'
}

export const FormToggle: React.FC<FormToggleProps> = ({
  formik,
  name,
  label,
  className = '',
  isDisabled = false,
  isRequired,
  labelSize,
  infoText,
  highlight,
  entity,
  align = 'end',
}) => {
  const { t } = useT()

  const errorMessage = getIn(formik.errors, name, null)
  const touched = getIn(formik.touched, name, '')
  const value = getIn(formik.values, name, '')

  const resolvedLabel = label ?? (entity ? t(`${entity}.label`) : undefined)

  return (
    <div className={`row ${className}`}>
      <div className={`d-flex justify-content-${align} align-items-center`}>
        {resolvedLabel && (
          <Label
            className='pe-2'
            isRequired={isRequired}
            size={labelSize}
            infoText={infoText}
            highlight={highlight}
          >
            {resolvedLabel}
          </Label>
        )}
        <ToggleInput
          checked={value}
          onChange={(value: boolean) => formik.setFieldValue(name, value)}
          disabled={isDisabled}
          ariaLabel={resolvedLabel}
        />
      </div>
      {touched && errorMessage && <ErrorLabel>{errorMessage}</ErrorLabel>}
    </div>
  )
}
